import {useState} from 'react';
import {useInfiniteQuery} from 'react-query';
import {IGetMyAdsPayload} from '../../../../models/payload/myAddsPayload';
import {postOwnerType} from '../../../../models/post/postOwnerType';
import {getMyAds} from '../../../../services/myAd';

const useGetMyAdds = () => {
  const [filter, setFilter] = useState<IGetMyAdsPayload>({
    profile_type: postOwnerType.SUPPLIER,
  });
  const {data, isLoading, fetchNextPage ,refetch} = useInfiniteQuery(
    ['MyAds', filter],
    ({pageParam = 1, queryKey}) =>
      getMyAds(queryKey[1] as IGetMyAdsPayload, pageParam),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages[allPages.length - 1].next
          ? allPages[allPages.length - 1].next
          : undefined;
      },
    },
  );

  return {data, isLoading, filter, setFilter, fetchNextPage ,refetch};
};

export default useGetMyAdds;
